"use strict";
/**
 * Shared error types for consistent error handling across the application
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=api.js.map